import { render, staticRenderFns } from "./textarea-wrapper.code.md?vue&type=template&id=121d9aba&"
import script from "./textarea-wrapper.code.md?vue&type=script&lang=ts&"
export * from "./textarea-wrapper.code.md?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../storefront/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports